import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  constructor(private _http: HttpClient) {
  }

  getRoles() {
    return this._http.get('assets/roles.json');
  }

}
